import React from 'react';
import { Grid, Box, makeStyles } from '@material-ui/core';
import { AlertTriangle, X } from 'react-feather';
// Redux Related
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from 'src/store/rootReducer';
import { closePaymentAlert } from 'src/store/emissionPolicy/actions';

const useStyles = makeStyles(() => ({
  container: {
    minHeight: 56,
    padding: 16,
    borderRadius: 10,
    backgroundColor: '#FFEFD0',
  },
  text: {
    fontWeight: 400,
    fontSize: 15,
    color: '#623601',
    textOverflow: 'wrap',
  },
  close: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

export const PaymentAlertMessage = ({
  closePaymentAlertAction,
  showPaymentAlert,
}: Props): JSX.Element => {
  const classes = useStyles();

  if (!showPaymentAlert) {
    return <div data-testid="empty-message" />;
  }

  return (
    <Grid container className={classes.container} data-testid="full-message">
      <Box display="flex" sx={{ width: '100%' }}>
        <Box sx={{ width: 26, marginRight: 10 }}>
          <AlertTriangle color="#E37E07" size={24} />
        </Box>
        <Box flexGrow={1} className={classes.text}>
          Verifica los datos de la tarjeta o añade otra tarjeta para continuar.
        </Box>
        <Box sx={{ width: 26 }}>
          <Box className={classes.close}>
            <X
              data-testid="close-icon"
              color="#E37E07"
              onClick={closePaymentAlertAction}
            />
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export const mapStateToProps = (
  state: RootState,
): {
  showPaymentAlert: boolean;
} => ({
  showPaymentAlert: state.emissionPolicy.showPaymentAlert,
});
const reduxActions = {
  closePaymentAlertAction: closePaymentAlert,
};

const connector = connect(mapStateToProps, reduxActions);

type Props = ConnectedProps<typeof connector>;

export default connector(PaymentAlertMessage);
